<template>
  <label
    :class="['ui-checkbox', { 'ui-checkbox--checked': isChecked, 'ui-checkbox--error': error, 'ui-checkbox--disabled': disabled }]"
  >
    <input
      class="visually-hidden ui-checkbox__input"
      :value="checkedValue"
      :checked="value === checkedValue"
      :disabled="disabled"
      type="checkbox"
      @change="check"
    />
    <span class="ui-checkbox__state">
      <svg class="ui-checkbox__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.7064 5.29279C16.8939 5.48031 16.9992 5.73462 16.9992 5.99979C16.9992 6.26495 16.8939 6.51926 16.7064 6.70679L8.70643 14.7068C8.5189 14.8943 8.2646 14.9996 7.99943 14.9996C7.73427 14.9996 7.47996 14.8943 7.29243 14.7068L3.29243 10.7068C3.11027 10.5182 3.00948 10.2656 3.01176 10.0034C3.01403 9.74119 3.1192 9.49038 3.30461 9.30497C3.49002 9.11956 3.74083 9.01439 4.00303 9.01211C4.26523 9.00983 4.51783 9.11063 4.70643 9.29279L7.99943 12.5858L15.2924 5.29279C15.48 5.10532 15.7343 5 15.9994 5C16.2646 5 16.5189 5.10532 16.7064 5.29279Z"
          fill="currentColor"
        />
      </svg>
    </span>
    <span v-if="label || $slots.label" class="ui-checkbox__label">
      <slot name="label">{{ label }}</slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'ui-checkbox',
  emits: ['input', 'change'],
  props: {
    value: {
      type: [String, Number, Boolean],
      default: true,
    },
    checkedValue: {
      type: [String, Number, Boolean],
      default: true,
    },
    uncheckedValue: {
      default: false,
    },
    checked: {
      type: Boolean,
      default: null,
    },
    label: {
      type: String,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isChecked() {
      if (this.checked !== null) {
        return this.checked
      }

      return this.value === this.checkedValue
    },
  },
  methods: {
    check(event) {
      const value = event.target.checked ? this.checkedValue : this.uncheckedValue

      this.$emit('input', value)

      if (this.checked !== null) {
        this.$emit('change', value)
      }
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.ui-checkbox
  display: flex
  gap: 12px
  font-size: 14px

  &--checked
    .ui-checkbox
      &__icon
        opacity: 1

  &--disabled
    opacity: var(--field-opacity-disabled, 0.7)
    pointer-events: none

    .ui-checkbox
      &__state
        background-color: var(--field-disabled-bg-color, #EDEDED)

  &--error
    .ui-checkbox
      &__state
        border-color: $error

  &__state
    flex-shrink: 0
    position: relative
    width: 24px
    height: 24px
    border-radius: 4px
    background: transparent
    border: var(--field-border-width, 1px) solid var(--field-border-color, #C8C8C8)
    transition: border .2s, background-color .2s

  &__icon
    position: absolute
    top: 1px
    left: 1px
    pointer-events: none
    opacity: 0
    transition: opacity .2s
    color: var(--field-icon-color, $cyan)

  &__label
    position: relative
    color: var(--field-text-color, $black)
    line-height: 24px
    cursor: pointer
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/Checkbox.vue